module.exports = __webpack_public_path__ + "img/appAsset-brand--AmericanExpress.a49b82f4.svg";